import React from 'react';
import { AlertCircle, ArrowLeft, Settings } from 'lucide-react';

const ComingSoon = ({ feature }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-yellow-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md text-center border-4 border-yellow-200">
        <div className="w-20 h-20 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
          <Settings className="w-10 h-10 text-white animate-spin" style={{ animationDuration: '3s' }} />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          🚧 {feature} Coming Soon!
        </h1>
        
        <p className="text-gray-500 mb-6">
          We're setting up this feature. It will be available very soon!
        </p>

        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-6">
          <p className="text-sm text-yellow-800">
            <AlertCircle className="w-4 h-4 inline mr-1" />
            For now, please contact us directly to register or for any queries.
          </p>
        </div>

        <div className="space-y-3">
          <a
            href="https://wa.me/919398869329?text=Hi! I want to register at MINDSPACE Reading Room."
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full py-3 bg-green-500 text-white rounded-xl font-bold hover:bg-green-600 transition"
          >
            💬 Contact on WhatsApp
          </a>
          
          <a
            href="/"
            className="block w-full py-3 border-2 border-gray-300 text-gray-700 rounded-xl font-bold hover:bg-gray-50 transition"
          >
            <ArrowLeft className="w-4 h-4 inline mr-1" /> Back to Home
          </a>
        </div>

        <p className="text-xs text-gray-400 mt-6">
          Call us: 9398869329
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
